import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import type { OffersSchemas } from "api-types";
import type { AxiosResponse } from "axios";

import { useOfferRequestPath } from "../hooks/use-offer-request-path";

export type CustomOfferParams = Omit<OffersSchemas.BuildOfferParams, "customOfferId" | "productRequestId" | "userId">;

export const useGetCustomOfferDetailsQuery = (
  customOfferId: number,
  productRequestId: string,
  params: CustomOfferParams
): UseQueryResult<OffersSchemas.BuildOfferInfo> => {
  const client = useAxios();
  const requestPath = useOfferRequestPath().getCustomOfferDetails(productRequestId, customOfferId);

  return useQuery({
    queryKey: ["getCustomOfferDetails", params],
    queryFn: () => client.get<OffersSchemas.BuildOfferInfo>(requestPath, { params }),
    select: ({ data }: AxiosResponse): OffersSchemas.BuildOfferInfo => data,
    throwOnError: true,
  });
};
